import { View, Text } from "react-native";
import React from "react";
import GlobalStyles from "../../../../globalStyles/globalStyles";
import Brand from "../../../../assets/Icons/BrandIcons";

export default function CardEmpty({ text }: { text: string }) {
  return (
    <View
      style={{
        alignItems: "center",
        justifyContent: "center",
        marginTop: 50,
      }}
    >
      <View
        style={{
          transform: [{ scale: 1.4 }],
        }}
      >
        <Brand.EmptyIcon />
      </View>
      <Text
        style={[
          GlobalStyles.title1,
          {
            fontSize: 24,
            opacity: 0.5,
            lineHeight: 26,
            textAlign: "center",
            width: "80%",
            marginTop: 20,
          },
        ]}
      >
        {text}
      </Text>
    </View>
  );
}
